<template>
  <div class="px-padding-36 flex flex-col justify-center py-10">
    <div class="gap-size-12 flex flex-col">
      <p class="text-font-18 font-medium">계좌 비밀번호 재설정</p>
      <p class="text-font-14">새 계좌 비밀번호를 다시 한번 입력해주세요</p>
    </div>

    <div class="gap-size-12 mt-size-36 flex flex-col">
      <BasePIN :pin="pin" @key-press="handleKeyPress" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { BasePIN } from '@template/ui';

const pin = defineModel<string[]>('pin', { required: true });

const KEYPAD_SPECIAL_KEYS = {
  BACKSPACE: 'BACKSPACE',
  EMPTY: 'EMPTY',
} as const;

const handleKeyPress = (key: string) => {
  const newPassword = [...pin.value];
  if (key === KEYPAD_SPECIAL_KEYS.BACKSPACE) {
    newPassword.pop();
  } else {
    newPassword.push(key);
  }
  pin.value = newPassword;
};
</script>
